// Local translations
export const T = {
  en_GB: {
    activeSessions: "Active Sessions",
    description:
      "Manage your active sessions across different devices. You can log out of other devices if you notice any suspicious activity.",
    loadingSessions: "Loading sessions...",
    failedToLoadSessions: "Failed to load sessions",
    failedToRevokeSessions: "Failed to revoke sessions",
    allOtherDevicesLoggedOut: "All other devices have been logged out",
    failedToUntrustDevice: "Failed to untrust device",
    untrustDeviceSuccess:
      "This device is no longer trusted. You will need to enter 2FA on next login.",
    unknownDevice: "Unknown device",
    unknownBrowser: "Unknown browser",
    unknownIp: "Unknown IP",
    current: "Current",
    trusted: "Trusted",
    logOutOtherDevices: "Log out other devices",
    untrustThisDevice: "Untrust this device",
  },
  nb_NO: {
    activeSessions: "Aktive økter",
    description:
      "Administrer dine aktive økter på forskjellige enheter. Du kan logge ut av andre enheter hvis du oppdager mistenkelig aktivitet.",
    loadingSessions: "Laster økter...",
    failedToLoadSessions: "Kunne ikke laste økter",
    failedToRevokeSessions: "Kunne ikke tilbakekalle økter",
    allOtherDevicesLoggedOut: "Alle andre enheter har blitt logget ut",
    failedToUntrustDevice: "Kunne ikke fjerne tillit til enhet",
    untrustDeviceSuccess:
      "Denne enheten er ikke lenger klarert. Du må skrive inn 2FA ved neste innlogging.",
    unknownDevice: "Ukjent enhet",
    unknownBrowser: "Ukjent nettleser",
    unknownIp: "Ukjent IP",
    current: "Nåværende",
    trusted: "Klarert",
    logOutOtherDevices: "Logg ut andre enheter",
    untrustThisDevice: "Fjern tillit til denne enheten",
  },
} as const;
